import { ref } from 'vue';


const isShow = ref(false);
const options = ref({
    title: '',
    confirmButtonText: null,
    cancelButtonText: null,
    description: null,
    accept: null,
    reject: null,
    hasShowAgainNote: null,
    showAgainNote: null,
});

const handleConfirm = async (...args) => {
    await options.value.accept?.(...args);
    isShow.value = false;
};

const handleCancel = async (...args) => {
    await options.value.reject?.(...args);
    isShow.value = false;
};

export const useConfirmModal = () => ({
    isShow,
    options,
    handleConfirm,
    handleCancel,
});

/**
 * @typedef {object} ConfirmOptions
 * @property {string} title
 * @property {string} confirmButtonText
 * @property {string} cancelButtonText
 * @property {string} [description]
 * @property {string} [hasShowAgainNote]
 * @property {string} [showAgainNote]
 * @property {Function} accept
 * @property {Function} reject
 * /

/**
 * @param {ConfirmOptions} confirmOptions
 */
const confirm = confirmOptions => {
    options.value = confirmOptions;
    isShow.value = true;
};

export const useConfirm = () => confirm;


